module.exports = __webpack_public_path__ + "assets/images/Data-managment.svg";